import { useContext } from 'react';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../context/flowBuilderContext';

export function useIsCurrentActiveNode(nodeId: string): boolean {
    const { currentActiveNodeConfig } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    
    return nodeId === currentActiveNodeConfig?.nodeId;
}
